import { render, staticRenderFns } from "./BulkContactsNew.vue?vue&type=template&id=09b51d8c"
import script from "./BulkContactsNew.vue?vue&type=script&lang=js"
export * from "./BulkContactsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports